import React, { useEffect, useState } from 'react'

import { convertMsToTime } from '@components/duration-input.component'
import { getChallengeResponsesForChallenge } from '@src/pages/workflow/settings/analytics.resource'
import { toastService } from '@utils/toast.service'
import { WorkflowLeaderboard } from './workflow-leaderboard.component'

type WorkflowLeaderboardItemDurationProps = {
  isAdmin: boolean
  workflowChallenge: WorkflowChallenge
  onEdit: (challenge: WorkflowChallenge) => void
  onDelete: (id: string) => void
  participantsCount: number
}

export function WorkflowLeaderboardItemDuration({
  isAdmin,
  workflowChallenge,
  onEdit,
  onDelete,
  participantsCount,
}: WorkflowLeaderboardItemDurationProps) {
  const [responses, setResponses] = useState<any[]>([])

  useEffect(() => {
    getChallengeResponsesForChallenge(workflowChallenge as any)
      .then(setResponses)
      .catch(err => {
        console.log(err)
        toastService.error(
          'There was an error retrieving challenge data. Please try again later.',
        )
      })
  }, [])

  function displayValue({ value }: { value: number }) {
    return convertMsToTime(value).join(':')
  }

  function displayGoal(value: string | number) {
    return convertMsToTime(value).join(':')
  }

  return (
    <WorkflowLeaderboard
      workflowChallenge={workflowChallenge}
      processValue={({ value }: { value: string | number }) => ({ value: Number(value) })}
      responses={responses}
      displayGoal={displayGoal}
      displayValue={displayValue}
    >
      <WorkflowLeaderboard.Header
        participantsCount={participantsCount}
        canEdit={isAdmin}
        onEdit={onEdit}
        onDelete={onDelete}
      />
      <WorkflowLeaderboard.Body />
    </WorkflowLeaderboard>
  )
}
